<template>
  <div>
    <div class="menu-title">模板管理</div>
    <div class="menu-content">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="模板内容：">
          <el-input v-model="query.LIKES_content" placeholder="请输入模板内容" clearable @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreate">添加</el-button>
      </div>
      <div class="table-list">
        <el-table v-loading="loading" :data="result.records" style="width: 100%">
          <el-table-column type="index" label="序号" width="70" />
          <el-table-column prop="content" label="模板内容" min-width="240" show-overflow-tooltip />
          <el-table-column label="标签" min-width="190">
            <template slot-scope="scope">
              <span>{{ tagNames(scope.row.tags) || '未设置' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="配图" width="140">
            <template slot-scope="scope">
              <div v-if="splitCsv(scope.row.imageUrl).length" class="template-table-images">
                <el-image
                  :src="imageSrc(splitCsv(scope.row.imageUrl)[0])"
                  :preview-src-list="splitCsv(scope.row.imageUrl).map(imageSrc)"
                  fit="cover"
                />
                <span v-if="splitCsv(scope.row.imageUrl).length > 1">共 {{ splitCsv(scope.row.imageUrl).length }} 张</span>
              </div>
              <span v-else>未设置</span>
            </template>
          </el-table-column>
          <el-table-column label="背景图" width="100">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.backgroundImageUrl"
                class="template-table-background"
                :src="imageSrc(scope.row.backgroundImageUrl)"
                :preview-src-list="[imageSrc(scope.row.backgroundImageUrl)]"
                fit="cover"
              />
              <span v-else>未设置</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180" />
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="openDetail(scope.row)">详情</el-button>
              <el-button type="text" icon="el-icon-edit" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="small" @click="removeRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-box">
        <el-pagination
          background
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="result.total"
          layout="total, sizes, prev, pager, next"
          @current-change="changePage"
          @size-change="changeSize"
        />
      </div>
    </div>
    <el-dialog title="模板配图详情" :visible.sync="detailVisible" width="980px" custom-class="memory-template-detail-dialog" @closed="closeDetail">
      <div class="template-detail-toolbar">
        <span class="template-detail-content">{{ detailTemplate ? detailTemplate.content : '' }}</span>
        <el-button type="text" icon="el-icon-refresh" :loading="detailLoading" @click="loadDetail">刷新</el-button>
      </div>
      <el-table v-loading="detailLoading" :data="detailImages" border class="template-detail-table" empty-text="暂无配图解析记录">
        <el-table-column prop="sortOrder" label="顺序" width="65">
          <template slot-scope="scope">{{ scope.row.sortOrder + 1 }}</template>
        </el-table-column>
        <el-table-column label="配图" width="86">
          <template slot-scope="scope">
            <el-image class="template-detail-image" :src="imageSrc(scope.row.imagePath)" :preview-src-list="detailImages.map(item => imageSrc(item.imagePath))" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="imagePath" label="图片路径" min-width="170" show-overflow-tooltip />
        <el-table-column prop="imageMd5" label="MD5" width="245" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.imageMd5 || '--' }}</template>
        </el-table-column>
        <el-table-column prop="imageDescription" label="描述" min-width="240">
          <template slot-scope="scope"><span class="template-detail-description">{{ scope.row.imageDescription || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="parseStatus" label="解析状态" width="100">
          <template slot-scope="scope">{{ parseStatusLabel(scope.row.parseStatus) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="form.id == null ? '添加模板' : '编辑模板'" :visible.sync="dialogVisible" :close-on-click-modal="false" width="760px" custom-class="memory-template-dialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="模板内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="6" placeholder="请输入模板内容" />
        </el-form-item>
        <el-form-item label="标签">
          <el-select v-model="form.tags" multiple filterable clearable :loading="tagsLoading" placeholder="选择或输入标签" style="width: 100%" @change="normalizeTags">
            <el-option v-for="tag in tagOptions" :key="tag.id" :label="tag.name" :value="tag.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="配图">
          <div class="template-image-list">
            <div v-for="(path, index) in form.imagePaths" :key="`${index}-${path}`" class="template-image-item">
              <el-image :src="imageSrc(path)" :preview-src-list="form.imagePaths.map(imageSrc)" fit="cover" />
              <el-button class="template-image-remove" type="text" icon="el-icon-close" title="移除图片" aria-label="移除图片" @click.stop="removeImage(index)" />
            </div>
            <el-upload
              class="template-upload-tile"
              action="#"
              accept="image/jpeg,image/png,image/gif,image/webp,image/bmp"
              multiple
              :auto-upload="false"
              :show-file-list="false"
              :on-change="uploadImage"
            >
              <i class="el-icon-plus template-upload-icon" title="添加图片" />
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="背景图">
          <el-upload
            class="template-upload-tile"
            action="#"
            accept="image/jpeg,image/png,image/gif,image/webp,image/bmp"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadBackground"
          >
            <img v-if="form.backgroundImageUrl" class="template-background-preview" :src="imageSrc(form.backgroundImageUrl)"  />
            <i v-else class="el-icon-plus template-upload-icon" title="添加图片" />
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" :disabled="pendingUploads > 0 || !tagsReady" @click="save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request, { getFileUrl } from '@/utils/request';

const api = '/core/memory-circle-template';

function splitCsv(value) {
  return typeof value === 'string' ? value.split(',').map(part => part.trim()).filter(Boolean) : [];
}

export default {
  name: 'MemoryCircleTemplateManage',
  data() {
    return {
      query: { pageNo: 1, pageSize: 10, LIKES_content: '', DESCI_createTime: 1 },
      result: { records: [], total: 0 },
      tagOptions: [],
      tagsLoading: false,
      tagsReady: false,
      tagLoadVersion: 0,
      form: { id: null, content: '', tags: [], imagePaths: [], backgroundImageUrl: '' },
      rules: { content: [{ required: true, whitespace: true, message: '请输入模板内容', trigger: 'blur' }] },
      fileBase: getFileUrl(),
      detailVisible: false,
      detailTemplate: null,
      detailImages: [],
      detailLoading: false,
      detailRequestVersion: 0,
      dialogVisible: false,
      loading: false,
      saving: false,
      pendingUploads: 0,
      dialogVersion: 0,
      backgroundUploadVersion: 0
    };
  },
  created() {
    this.uploadQueue = Promise.resolve();
  },
  mounted() {
    this.load();
    this.loadTags();
  },
  methods: {
    splitCsv,
    imageSrc(path) {
      return this.fileBase + path;
    },
    parseStatusLabel(status) {
      return { pending: '待解析', processing: '解析中', ready: '已完成', failed: '解析失败' }[status] || status || '未知';
    },
    openDetail(row) {
      this.detailTemplate = row;
      this.detailImages = [];
      this.detailVisible = true;
      return this.loadDetail();
    },
    loadDetail() {
      if (!this.detailTemplate) return Promise.resolve();
      const version = ++this.detailRequestVersion;
      this.detailLoading = true;
      return request({ url: `${api}/${this.detailTemplate.id}/images`, method: 'get' })
        .then(images => {
          if (version === this.detailRequestVersion && this.detailVisible) this.detailImages = images || [];
        })
        .finally(() => {
          if (version === this.detailRequestVersion) this.detailLoading = false;
        });
    },
    closeDetail() {
      this.detailRequestVersion += 1;
      this.detailTemplate = null;
      this.detailImages = [];
      this.detailLoading = false;
    },
    tagNames(value) {
      return this.readTagNames(value).join('、');
    },
    readTagNames(value) {
      const names = splitCsv(value).map(token => {
        if (this.tagOptions.some(tag => tag.name === token)) return token;
        const tag = this.tagOptions.find(item => String(item.id) === token);
        return tag ? tag.name : token;
      });
      return Array.from(new Set(names));
    },
    normalizeTags(values) {
      const names = values.map(value => String(value).trim());
      if (names.some(name => !name || name.includes(','))) {
        this.$message.error('标签不能为空，也不能包含英文逗号');
      }
      this.form.tags = Array.from(new Set(names.filter(name => name && !name.includes(','))));
    },
    loadTags() {
      const version = ++this.tagLoadVersion;
      this.tagsLoading = true;
      this.tagsReady = false;
      return request({ url: '/core/memory-circle-tag/query_list', method: 'post', data: { ASCI_sort: 1 } })
        .then(tags => {
          if (version !== this.tagLoadVersion) return;
          this.tagOptions = tags || [];
          if (this.dialogVisible) this.form.tags = this.readTagNames(this.form.tags.join(','));
          this.tagsReady = true;
        }).finally(() => {
          if (version === this.tagLoadVersion) this.tagsLoading = false;
        });
    },
    load() {
      this.loading = true;
      return request({ url: `${api}/query_pages`, method: 'post', data: this.query })
        .then(result => { this.result = result; })
        .finally(() => { this.loading = false; });
    },
    search() {
      this.query.pageNo = 1;
      this.load();
    },
    changePage(page) {
      this.query.pageNo = page;
      this.load();
    },
    changeSize(size) {
      this.query.pageSize = size;
      this.query.pageNo = 1;
      this.load();
    },
    openCreate() {
      this.dialogVersion += 1;
      this.form = { id: null, content: '', tags: [], imagePaths: [], backgroundImageUrl: '' };
      this.dialogVisible = true;
      this.loadTags();
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    openEdit(row) {
      this.dialogVersion += 1;
      this.form = {
        id: row.id,
        content: row.content || '',
        tags: this.readTagNames(row.tags),
        imagePaths: splitCsv(row.imageUrl),
        backgroundImageUrl: row.backgroundImageUrl || ''
      };
      this.dialogVisible = true;
      this.loadTags();
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    removeRow(row) {
      this.$confirm('确定删除该模板吗？', '提示', { type: 'warning' })
        .then(() => request({ url: `${api}/remove/${row.id}`, method: 'post' }))
        .then(() => {
          this.$message.success('删除成功');
          if (this.result.records.length === 1 && this.query.pageNo > 1) this.query.pageNo -= 1;
          this.load();
        })
        .catch(() => {});
    },
    removeImage(index) {
      this.form.imagePaths.splice(index, 1);
    },
    uploadImage(file) {
      this.queueImage(file, false);
    },
    uploadBackground(file) {
      this.queueImage(file, true);
    },
    queueImage(file, background) {
      const raw = file.raw;
      if (!raw || !['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'].includes(raw.type)) {
        this.$message.error('请选择 JPG、PNG、GIF、WebP 或 BMP 图片');
        return;
      }
      if (raw.size > 20 * 1024 * 1024) {
        this.$message.error('图片不能超过 20 MB');
        return;
      }
      const version = this.dialogVersion;
      const backgroundVersion = background ? ++this.backgroundUploadVersion : this.backgroundUploadVersion;
      this.pendingUploads += 1;
      this.uploadQueue = this.uploadQueue.then(() => {
        if (version !== this.dialogVersion || !this.dialogVisible) return;
        const data = new FormData();
        data.append('file', raw);
        return request({ url: '/upload/file/words', method: 'post', data })
          .then(path => {
            if (version !== this.dialogVersion || !this.dialogVisible) return;
            if (background && backgroundVersion !== this.backgroundUploadVersion) return;
            if (!path) {
              this.$message.error('图片上传失败');
              return;
            }
            if (background) this.form.backgroundImageUrl = path;
            else this.form.imagePaths.push(path);
          })
          .catch(() => {});
      }).then(() => { this.pendingUploads -= 1; });
    },
    save() {
      if (this.pendingUploads || !this.tagsReady || this.saving) return;
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const editing = this.form.id != null;
        this.saving = true;
        request({
          url: `${api}/${editing ? 'modify' : 'create'}`,
          method: 'post',
          data: {
            ...(editing ? { id: this.form.id } : {}),
            content: this.form.content.trim(),
            tags: this.form.tags.join(','),
            imageUrl: this.form.imagePaths.join(','),
            backgroundImageUrl: this.form.backgroundImageUrl
          }
        }).then(() => {
          this.$message.success(editing ? '编辑成功' : '添加成功');
          this.dialogVisible = false;
          this.load();
        }).finally(() => { this.saving = false; });
      });
    }
  }
};
</script>

<style lang="scss">
.memory-template-dialog { max-width: calc(100vw - 32px); }
.memory-template-detail-dialog { max-width: calc(100vw - 32px); }
.template-detail-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 12px; }
.template-detail-content { min-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.template-detail-table { width: 100%; }
.template-detail-image { width: 48px; height: 48px; }
.template-detail-description { white-space: pre-wrap; overflow-wrap: anywhere; }
.template-table-images { display: flex; align-items: center; gap: 8px; }
.template-table-images .el-image { width: 48px; height: 48px; flex: none; }
.template-table-background { width: 48px; height: 48px; }
.template-image-list { display: flex; flex-wrap: wrap; gap: 12px; }
.template-image-item { position: relative; width: 178px; height: 178px; flex: none; }
.template-image-item .el-image { width: 100%; height: 100%; }
.template-image-remove { position: absolute; top: 4px; right: 4px; z-index: 1; width: 28px; height: 28px; padding: 0; border-radius: 50%; background: #fff; }
.template-background-preview { display: block; width: 100%; height: 100%; object-fit: cover; }
.template-upload-tile .el-upload { display: flex; align-items: center; justify-content: center; width: 178px; height: 178px; border: 1px dashed #d9d9d9; border-radius: 6px; box-sizing: border-box; cursor: pointer; }
.template-upload-tile .el-upload:hover { border-color: #409eff; }
.template-upload-icon { font-size: 28px; color: #8c939d; }
@media (max-width: 600px) {
  .template-image-item, .template-upload-tile .el-upload { width: 130px; height: 130px; }
}
</style>
